//GLOBAL ENGLISH

const englishTranslations = {
  helloWorld: "Hello World",
  changeLocale: "Change language locale",
  changeTheme: "Change theme",

  auth: {
    signupHeading: "Sign Up",
    signupSubHeading:
      "Start creating your account now for more access to our dashboard",
    register: "REGISTER",
    signupWith: "Sign up With:",
    account: " Already have an account?",
    planetX:
      "Planet J is a web-based gaming platform designed for thrill-seekers who love the excitement of racing and the high stakes of betting. It combines the adrenaline of competitive racing with the strategic depth of adventure gaming.",
    name: "Name",
    email: "Email",
    password: "Password",
    loginHeading: "Login",
    loginSubHeading: "Insert your email and password to access your account",
    noAccount: "Don’t Have Account?",
    loginWith: "Login With:",
    connectWalletHeading: "Connect Wallet",
    connectWalletSubHeading:
      "Connect your wallet to get fastest way to access your account",
    connectWallet: "Connect Wallet",
    meNoAccount: "I Don’t have account",
    skip: "Skip for now",
    referralHeading: "Referral Code",
    referralHeadingSubHeading:
      "Enter if you have Referral Code, Leave it empty if you don’t have it.",
    referralFieldLabel: "Referral Code (Optional)",
    referralButtonText: "Continue",
    planetJ: "PlanetJ",
  },
  planetJSidebar:
    "Planet J is a web-based gaming platform designed for thrill-seekers who love the excitement of racing and the high stakes of betting. ",
  home: {
    topupButton: "Topup",
    withdrawButton: "Withdraw",
    removeWalletButton: "REMOVE WALLET",
    betNowButton: "BET NOW",
    findRandomMatchButton: "FIND RANDOM MATCH",
    specialEvent: "SPECIAL EVENT",
    doubleWinnings: "DOUBLE YOUR WINNINGS!",
    betOnRaces:
      " Bet on select races and earn double the rewards. Don't miss your chance to win big!",
  },
  bet: {
    placeBet: "PLACE BET",
    betPanel: "Bet Panel",
  },
  wallet: {
    topup: "Topup Now",
    add_wallet: "ADD WALLET",
  },
  select: "SELECT",
  back_to_home: "BACK TO HOME",
};

export default englishTranslations;
